/** @jsx h */
import { labels } from '../config';

const ResultTitle = ({ allResultCount }) => {
  return (
    <h2 className="result-count is-h3" aria-live="polite">
      {allResultCount === 1 && allResultCount > 0
        ? labels.results.foundSingular
        : `${allResultCount} ${labels.results.found}`}
    </h2>
  );
};

export default ResultTitle;
